import { TextField, Divider } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { ExternalLeadStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/externalLeadStore';
import { LEAD_OBJECT_TYPE } from '../leads/constants/constants';
import { useStore } from '@roc/client-portal-shared/hooks';

interface IDashboardAutocompleteField {
  store: ExternalLeadStore;
}

export const PeopleCriteriaComponentSelection = observer(({ disable }) => {
  const { cadenceStore } = useStore();
  const { dashboards, standardDashboards, currentDashboardId } = cadenceStore;
  const store = cadenceStore;

  const onSelect = (opt) => {
    cadenceStore.settingDashboardId(opt);
  }

  const customOptions = dashboards?.map(dashboard => ({
    label: dashboard.name,
    value: dashboard.id,
    isStandard: false,
    type: dashboard?.baseObject
  }))

  const standardOptions = standardDashboards.map(standardDashboard => ({
    label: standardDashboard.name,
    value: standardDashboard.dashboardListId,
    isStandard: true,
    type: standardDashboard?.objectType
  }))

  const options = standardOptions.concat(customOptions)

  useEffect(() => {
    if (currentDashboardId !== null) {
      const selectedDashboard = options.find(opt => opt.value === currentDashboardId?.value);
      if (selectedDashboard) {
        onSelect(selectedDashboard);
      }
    }
  }, []);

  return (
    <Autocomplete
      id="leads-dashboard-autocomplete"
      selectOnFocus
      handleHomeEndKeys
      options={options}
      defaultValue={options.find(o => o.value === currentDashboardId?.value) || {}}
      inputValue={store.searchText}
      size="small"
      blurOnSelect={true}
      onInputChange={(e, value) => (store.searchText = value)}
      renderInput={params => <TextField variant={'outlined'} {...params} />}
      getOptionLabel={option => option?.label ?? ''}
      getOptionSelected={(option, selected) => option?.value === selected?.value}
      onChange={(event, option) => onSelect(option)}
      placeholder={'Select lead dashboard name'}
      fullWidth
      disabled={disable}
      groupBy={(option: any) => {
        return option.isStandard && option.type === LEAD_OBJECT_TYPE ? 'Standard Lead Views' : option.isStandard ? 'Standard Contacts Views' : 'Custom Views';
      }}
    />
  );
});
